import type { JSX } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { useTheme } from '@hooks/useTheme';
import { useAnalytics } from '@hooks/useAnalytics';

import Home from '@components/Home';
import ArticlePage from '@components/article/ArticlePage';
import AsterionPage from '@components/asterion/AsterionPage';

export default function App(): JSX.Element {
  const [theme, toggleTheme] = useTheme();
  useAnalytics();
  const props = { theme, onToggleTheme: toggleTheme };

  return (
    <Routes>
      {/* ── Français : la racine, sans préfixe ── */}
      <Route path="/" element={<Home {...props} />} />
      <Route path="/asterion" element={<AsterionPage {...props} />} />
      <Route path="/articles" element={<ArticlePage {...props} />} />
      <Route path="/articles/:slug" element={<ArticlePage {...props} />} />

      {/* ── Anglais : même arbre sous /en, comme solutions-asterion.com ── */}
      <Route path="/en" element={<Home {...props} />} />
      <Route path="/en/asterion" element={<AsterionPage {...props} />} />
      <Route path="/en/articles" element={<ArticlePage {...props} />} />
      {/* Les articles n'existent qu'en français ici : une adresse anglaise
          d'article renvoie vers l'index anglais, dont les cartes mènent aux
          traductions publiées sur le blog Asterion. */}
      <Route path="/en/articles/:slug" element={<Navigate to="/en/articles" replace />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
